module.exports = __webpack_public_path__ + "img/icon-box-48.a91e181a.svg";